import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "add-audio-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.36876 4.68213C10.506 3.71683 12.25 4.52733 12.25 6.017V17.983C12.25 19.473 10.507 20.2827 9.36903 19.3181L5.60001 16.125H3.5C2.53379 16.125 1.75 15.3412 1.75 14.375V9.625C1.75 8.65879 2.53379 7.875 3.5 7.875H5.60001L9.36876 4.68213ZM10.75 6.017C10.75 5.80274 10.5002 5.68925 10.3394 5.82574L6.3598 9.19725C6.22434 9.31202 6.05255 9.375 5.875 9.375H3.5C3.36221 9.375 3.25 9.48722 3.25 9.625V14.375C3.25 14.5128 3.36221 14.625 3.5 14.625H5.875C6.05255 14.625 6.22434 14.688 6.3598 14.8028L10.3388 18.1738C10.5009 18.3112 10.75 18.197 10.75 17.983V6.017Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.9022 7.62264C15.1227 7.27203 15.5858 7.16661 15.9364 7.38717C17.352 8.27773 18.25 10.043 18.25 12.005C18.25 13.966 17.3524 15.733 15.9328 16.615C15.581 16.8337 15.1186 16.7257 14.9 16.3738C14.6813 16.022 14.7893 15.5596 15.1412 15.341C16.0456 14.779 16.75 13.542 16.75 12.005C16.75 10.469 16.046 9.22828 15.1376 8.65683C14.787 8.43627 14.6816 7.97325 14.9022 7.62264Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.9308 4.4476C18.2006 4.13325 18.6741 4.09709 18.9884 4.36683C20.9828 6.07817 22.25 8.8771 22.25 12.003C22.25 15.1249 20.9848 17.9214 18.9941 19.6336C18.68 19.9037 18.2065 19.8681 17.9364 19.5541C17.6663 19.24 17.7019 18.7665 18.0159 18.4964C19.6412 17.0986 20.75 14.7351 20.75 12.003C20.75 9.2669 19.6392 6.90183 18.0116 5.50518C17.6972 5.23544 17.6611 4.76195 17.9308 4.4476Z"
    }, null, -1)
  ])))
}
export default { render: render }